import { render, staticRenderFns } from "./c_tab_input.vue?vue&type=template&id=b2b70cba&scoped=true"
import script from "./c_tab_input.vue?vue&type=script&lang=js"
export * from "./c_tab_input.vue?vue&type=script&lang=js"
import style0 from "./c_tab_input.vue?vue&type=style&index=0&id=b2b70cba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b70cba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b70cba')) {
      api.createRecord('b2b70cba', component.options)
    } else {
      api.reload('b2b70cba', component.options)
    }
    module.hot.accept("./c_tab_input.vue?vue&type=template&id=b2b70cba&scoped=true", function () {
      api.rerender('b2b70cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_tab_input.vue"
export default component.exports